import { ref } from 'vue';
import type { NotificationVariant, ToastNotifications } from '@nsftx/seven-components';

const notifications = ref<ToastNotifications>([]);

export const useNotifications = () => {
  const setNotification = (
    message: string,
    variant: NotificationVariant = 'error',
    uuid = crypto.randomUUID()
  ) => {
    notifications.value.push({
      messages: [message || 'Something went wrong. Please reload or contact customer support'],
      variant,
      uuid,
      timeout: 10000
    });
  };

  return {
    notifications,
    setNotification
  };
};
